import { useState, useEffect } from 'react';

export default function useAuthBlob(fullUrl, token, enabled) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled || !fullUrl || !token) return;
    let revoke;
    fetch(fullUrl, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (!r.ok) throw new Error('fetch failed');
        return r.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        revoke = url;
        setBlobUrl(url);
      })
      .catch(() => setError(true));
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [fullUrl, token, enabled]);

  return { blobUrl, error };
}
